import React, { useRef } from 'react';
import docUpload from '../../../Assets/docUpload.png';
import warning from '../../../Assets/Warning.png';
import { Tooltip } from 'primereact/tooltip';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Button } from 'primereact/button';

export const WorkflowStatuses = {
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  PENDING: 'Pending',
  DELETE_PENDING: 'Delete Pending',
  DELETE_APPROVED: 'Delete Approved',
  DELETE_REJECTED: 'Delete Rejected',
};

export const FormTypes = {
  MULTI: 'MULTI UPDATE',
  UPDATE: 'SINGLE UPDATE',
  ADD: 'ADD',
};

export const getStatusCss = (validInvalid) => {
  switch (validInvalid) {
    case 'Valid':
      return '#209860';
    case 'Invalid':
      return '#F06373';
    default:
      return '#000000';
  }
};

export const INVALID_UPDATE_MSG = `This request is pending from Super Admin. Please try again after sometime.`;
export const setFileDetails = (event, setDocument, setDocumentName) => {
  const files = event.target.files;
  const fileName =
    files && files.length > 0 && files[0].name ? files[0].name : '';
  setDocument(files[0]);
  setDocumentName(fileName);
};


export const getMasterData = (data) => {
  return (data || []).map((d) => {
    if (!(d.recModifiedDate instanceof Date)) {
      const dateOnly =
        d && d.recModifiedDate ? d.recModifiedDate.toString().split(' - ') : [];
      if (dateOnly.length > 1) {
        const date = new Date(dateOnly[0]);
        const time = dateOnly[1];
        d.recModifiedDate = date;
        d.time = time;
      } else {
        d.recModifiedDate = '';
        d.time = '';
      }

      return d;
    }
    d.recModifiedDate = '';
    d.time = '';
    return d;
  });
};

export const docBodyTemplate = (option) => {
  return (
    <div className="text-center">
      <Tooltip target=".uploadImg" />
      <img
        src={docUpload}
        alt="doc-upload"
        className="uploadImg"
        data-pr-tooltip={option.attachedDoc}
        data-pr-position="bottom"
      />
    </div>
  );
};

export const RemarkBodyTemplate = (option) => {
  const op = useRef(null);

  const handleOverlay = (e) => {
    op.current.toggle(e);
  };

  return (
    <>
      {option.workflowStatus === WorkflowStatuses.REJECTED &&
      option.remarks !== '' ? (
        <>
          <Button
            icon={<img src={warning} alt="remark" />}
            rounded
            text
            aria-label="Remark"
            onMouseOver={(e) => handleOverlay(e)}
            onMouseLeave={(e) => handleOverlay(e)}
          />
          <OverlayPanel className="remark-overlay" ref={op}>
            {option.remarks}
          </OverlayPanel>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

const isSelectable = (data) => {
  return data.workflowStatus !== WorkflowStatuses.DELETE_PENDING;
};

export const isRowSelectable = (event) =>
  event.data ? isSelectable(event.data) : true;

export const emptyPropCheck = (propList, obj) => {
  return propList.every(
    (prop) => obj[prop] === '' || obj[prop] === null || obj[prop] === undefined
  );
};
